export default {
  general: {
    missing: 'Please provide the required field',
    invalid: 'Provided value is invalid',
  },
  name: {
    title: {
      missing: 'Please provide menu title',
    },
    description: {
      missing: 'Please provide menu description',
    },
  },
}